const preloadImages = (urls: string[]) => {
  urls.forEach((url) => {
    const image = new Image();
    image.src = url;
  });
};

export default preloadImages;
